<div class="wm-form use-expression">
    <div class="expression-editor" *ngIf="bindVariableService.allowedCategories.EXPRESSION">
        <div class="wm-code-editor-container">
            <wms-editor [options]="editorOptions" (onChange)="onExprChange()" #codeEditor></wms-editor>
        </div>
        <div class="expression-hint">
            <p><i class="wms wms-info-outline"></i> {{locale.MESSAGE_USE_FUNCTIONS_IN_EXPRESSIONS}} <a
                    href="{{useExpLink}}" target="_blank">{{locale.LABEL_ANCHOR_READ_MORE}}</a></p>
        </div>
    </div>
    <div class="small-tree-container" *ngIf="bindVariableService.allowedCategories.EXPRESSION">
        <wms-page-select  *ngIf="this.bindVariableService.dialogParams.showPageSelection"></wms-page-select>
        <div class="actions">
            <div class="btn-group">
                <button class="btn-default btn app-button" (click)="bindVariableService.insertText(' + ')"><span
                        class="btn-caption">+</span></button>
                <button class="btn-default btn app-button" (click)="bindVariableService.insertText(' - ')"><span
                        class="btn-caption">-</span></button>
                <button class="btn-default btn app-button" (click)="bindVariableService.insertText(' * ')"><span
                        class="btn-caption">*</span></button>
                <button class="btn-default btn app-button" (click)="bindVariableService.insertText(' / ')"><span
                        class="btn-caption">/</span></button>
            </div>
            <wms-search width="15em" (onSearch)="filterContent($event)"></wms-search>
        </div>
        <wms-tree id="usecase-search-box" [selectedNode]="bindVariableService.selectedNodeInBindDialog.expression"
            (nodeClick)="bindVariableService.onMixedTreeClick($event.dataItem.id,$event.dataItem.props); $event.dataItem.active = true;"
            [data]="bindVariableService.filteredMixedTree" sortBy="id" iconType="plus"
            [getChildren]="bindVariableService.getChildren" [externalSearchKey]="searchKey">
        </wms-tree>
    </div>
    <div class="expression-selector" *ngIf="bindVariableService.allowedCategories.EXPRESSION">
        <div class="form-group app-composite-widget clearfix">
            <label class="expr-label">{{locale.LABEL_PROPERTY_FORMATPATTERN}}</label>
            <select class="expr-control app-select form-control" (change)="resetExpr();setCustomPipeConfig(expr.fn);"
                [(ngModel)]="expr.fn">
                <optgroup label="">
                    <option *ngFor="let item of expressionFunctions  | keyvalue | orderBy:'value'" [value]="item.value">
                        <span *ngIf="item.value != 'custom'">{{item.value}}</span>
                    </option>
                </optgroup>
                <optgroup label="Content Sanitization (XSS)">
                    <option value="trustAs">{{locale.LABEL_PROPERTY_TRUSTAS}}</option>
                    <option value="sanitize">{{locale.LABEL_PROPERTY_SANITIZE}}</option>
                </optgroup>
                <optgroup label="Custom" *ngIf="!bindVariableService.isPrefabTemplate && !bindVariableService.isTemplateBundleType">
                    <ng-container *ngFor="let item  of customPipeOptions | keyvalue" >
                        <option *ngIf="expressionFunctions.indexOf(item.key) === -1" value="{{item.key}}">
                            {{item.key}}
                        </option>
                    </ng-container>
                    <option value="custompipe">
                        {{locale.MESSAGE_CUSTOM_PIPES_NOT_FOUND}}
                    </option>
                </optgroup>
            </select>
        </div>
        <div *ngIf="expr.fn === 'toDate'">
            <div class="expr-format">
                <datalist id="formatter-datetimepatterns">
                    <option *ngFor=" let pattern of dateTimePatterns">{{pattern}}</option>
                </datalist>
                <label class="expr-label" for="datepattern">{{locale.LABEL_PROPERTY_DATEPATTERN}}</label>
                <input class="expr-control form-control" id="datepattern" list="formatter-datetimepatterns" type="text"
                    [ngModelOptions]="{ updateOn: 'blur' }" [(ngModel)]="expr.datepattern" />
            </div>
        </div>
        <div *ngIf="expr.fn === 'toCurrency'">
            <div class="expr-format">
                <label class="expr-label">{{locale.LABEL_PROPERTY_SYMBOL}}</label>
                <datalist id="formatter-currency">
                    <option *ngFor="let currency of currencyOptions">{{currency}}</option>
                </datalist>
                <div class="input-group currency-wrapper">
                    <input class="form-control app-textbox" id="currency-option" list="formatter-currency" type="text"
                        [ngModelOptions]="{ updateOn: 'change' }" [(ngModel)]="defaults.currency"
                        (change)="setCurrencySymbol()" />
                    <span class="input-group-addon">{{expr.currency || defaults.currencySymbol}}</span>
                </div>
            </div>
            <div class="expr-format fraction-size">
                <label class="expr-label">{{locale.LABEL_PROPERTY_FRACTION_SIZE}}</label>
                <input class="form-control expr-control" [(ngModel)]="expr.fracSize" type="number" />
            </div>
        </div>
        <div *ngIf="expr.fn === 'prefix'">
            <div class="expr-format">
                <label class="expr-label">{{locale.LABEL_PROPERTY_PREFIX}}</label>
                <input class="form-control expr-control" [(ngModel)]="expr.prefix" type="text" />
            </div>
        </div>
        <div *ngIf="expr.fn === 'suffix'">
            <div class="expr-format">
                <label class="expr-label">{{locale.LABEL_PROPERTY_SUFFIX}}</label>
                <input class="form-control expr-control" [(ngModel)]="expr.suffix" type="text" />
            </div>
        </div>
        <div *ngIf="expr.fn === 'trustAs'">
            <div class="expr-format">
                <datalist id="formatter-trustas-securitycontexts">
                    <option *ngFor="let option of securityContextOptions">{{option}}</option>
                </datalist>
                <label class="expr-label"
                    for="trustas-securitycontext">{{locale.LABEL_PROPERTY_SECURITY_CONTEXT}}</label>
                <input class="expr-control form-control" id="trustas-securitycontext"
                    list="formatter-trustas-securitycontexts" type="text" [ngModelOptions]="{ updateOn: 'blur' }"
                    [(ngModel)]="expr.securitycontext" />
            </div>
        </div>
        <div *ngIf="expr.fn === 'sanitize'">
            <div class="expr-format">
                <datalist id="formatter-sanitize-securitycontexts">
                    <option *ngFor="let option of securityContextOptions">{{option}}</option>
                </datalist>
                <label class="expr-label"
                    for="sanitize-securitycontext">{{locale.LABEL_PROPERTY_SECURITY_CONTEXT}}</label>
                <input class="expr-control form-control" id="sanitize-securitycontext"
                    list="formatter-sanitize-securitycontexts" type="text" [ngModelOptions]="{ updateOn: 'blur' }"
                    [(ngModel)]="expr.securitycontext" />
            </div>
        </div>
        <div *ngIf="expr.fn === 'numberToString'">
            <div class="expr-format fraction-size">
                <label class="expr-label">{{locale.LABEL_PROPERTY_FRACTION_SIZE}}</label>
                <input class="expr-control form-control" [(ngModel)]="expr.fracSize" type="number" />
            </div>
        </div>
        <div *ngIf=" customPipeOptions && customPipeOptions[expr.fn] && customPipeOptions[expr.fn].config">
            <div class="expr-format" *ngFor="let item of customPipeOptions[expr.fn].config | keyvalue">
                <datalist
                    *ngIf="customPipeOptions[expr.fn].config[$any(item.key)].options && customPipeOptions[expr.fn].config[$any(item.key)].options"
                    id="formatter-custompipe">
                    <option *ngFor="let option of customPipeOptions[expr.fn].config[$any(item.key)].options">{{option}}
                    </option>
                </datalist>

                <label class="expr-label" for="customPipeOptions[expr.fn].config[key].name">
                    {{customPipeOptions[expr.fn].config[$any(item.key)].name}}</label>
                <input
                    [attr.list]="customPipeOptions[expr.fn].config[$any(item.key)].widget == 'select' ? 'formatter-custompipe':''"
                    class="expr-control form-control" id="customPipeOptions[expr.fn].config[key].name" type="text"
                    [(ngModel)]="expr[customPipeOptions[expr.fn].config[$any(item.key)].name]" />
            </div>
        </div>
        <p class="help-block" [innerHTML]="locale['MESSAGE_PROPERTY_FORMAT_' + expr.fn?.toUpperCase()]"></p>
        <button name="wm-apply-format-btn" title="Apply Format" class="button-primary btn app-button apply-button"
            (click)="constructExpression()">{{locale.LABEL_APPLY_FORMAT}}</button>
    </div>
</div>
